import * as Yup from 'yup';

export const SetUserEmailSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
});
